import React, { useState } from "react";
import axios from "axios";
import "./App.css";
import { API } from "./api";
import { IcoUser, IcoLock, IcoImage, IcoLink, IcoRestore } from "./components/Icons";

export default function LoginPopup({ onLogin }) {
  const [username, setUser] = useState("");
  const [password, setPass] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submitLogin = async (e) => {
    e?.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/login`, { username, password });
      if (res.data.status === "success") {
        onLogin(res.data.role, res.data.name || "", username, res.data.token || "");
      } else {
        setError(res.data.message || "Sai tên đăng nhập hoặc mật khẩu");
      }
    } catch {
      setError("Không kết nối được tới máy chủ");
    }
    setLoading(false);
  };

  return (
    <div className="login">
      <section className="login-hero">
        <div className="login-hero-inner">
          <span className="brand-mark large"><img src="/logo.png" alt="" /></span>
          <p className="login-eyebrow">Bệnh viện Hùng Vương Gia Lai</p>
          <h1>Ảnh Nội Bộ</h1>
          <p>Kho ảnh, video và tài liệu dùng chung cho website và các ứng dụng của bệnh viện.</p>

          <ul className="login-points">
            <li><span><IcoImage size={18} /></span> Lưu ảnh theo thư mục, xem lớn ngay trên trang</li>
            <li><span><IcoLink size={18} /></span> Chép link đúng cỡ để ảnh trên web tải nhanh</li>
            <li><span><IcoRestore size={18} /></span> Xóa nhầm vẫn khôi phục được trong 30 ngày</li>
          </ul>
        </div>
      </section>

      <section className="login-side">
        <form className="login-card" onSubmit={submitLogin}>
          <span className="brand-mark login-card-logo"><img src="/logo.png" alt="" /></span>
          <h2>Đăng nhập</h2>
          <p className="login-sub">Dùng mã số nhân viên và mật khẩu HVGL Office.</p>

          <label className="field">
            <span>Mã số nhân viên</span>
            <span className="field-box">
              <IcoUser size={17} />
              <input
                type="text"
                placeholder="Nhập mã số nhân viên…"
                value={username}
                onChange={(e) => setUser(e.target.value)}
                autoComplete="username"
                autoFocus
              />
            </span>
          </label>

          <label className="field">
            <span>Mật khẩu</span>
            <span className="field-box">
              <IcoLock size={17} />
              <input
                type="password"
                placeholder="Nhập mật khẩu…"
                value={password}
                onChange={(e) => setPass(e.target.value)}
                autoComplete="current-password"
              />
            </span>
          </label>

          {error && <div className="form-error">{error}</div>}

          <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
            {loading ? "Đang đăng nhập…" : "Đăng nhập"}
          </button>

          <p className="login-foot">
            © {new Date().getFullYear()} Hùng Vương Gia Lai<br />
            Powered by Phòng CNTT - leanhquan™
          </p>
        </form>
      </section>
    </div>
  );
}
